function IconMaterialCost({ size = "100%", fillColor = "none", strokeColor = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_112_1498)">
        <g clip-path="url(#clip1_112_1498)">
          <path d="M25.9519 18.3745C32.1715 18.3745 37.224 23.427 37.224 29.6467V47.5772C37.224 49.5277 35.6417 51.1178 33.6834 51.1178H18.2204C16.2699 51.1178 14.6797 49.5355 14.6797 47.5772V29.6467C14.6797 23.427 19.7322 18.3745 25.9519 18.3745Z" stroke={strokeColor} stroke-width="1.56667" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M30.5204 19.346V12.9775H21.3945V19.346" stroke={strokeColor} stroke-width="1.56667" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M17.1016 5.68457H37.4056C39.0584 5.68457 40.4057 7.0319 40.4057 8.68474V12.9774H20.8224C18.7701 12.9774 17.1016 11.3089 17.1016 9.25657V5.68457Z" stroke={strokeColor} stroke-width="1.56667" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M30.5234 12.9775L35.5289 19.5027C36.0381 20.1685 36.8293 20.5602 37.6674 20.5602H39.0696L36.8293 12.9854" stroke={strokeColor} stroke-width="1.56667" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M33.0234 28.2839V46.0264" stroke={strokeColor} stroke-width="1.56667" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_112_1498">
          <rect width="56" height="56" fill={fillColor} />
        </clipPath>
        <clipPath id="clip1_112_1498">
          <rect width="27.2835" height="47" fill={fillColor} transform="translate(13.9023 4.90112)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconMaterialCost;